import type { DashboardDataset, SalesRecord } from '../types';

const products = [
  { product: 'Phesgo Vial Maintenance dose(10ml) 1', brand: 'Phesgo', price: 6232.07 },
  { product: 'Phesgo Vial Loading dose(15ml) 1', brand: 'Phesgo', price: 10420.5 },
  { product: 'Perjeta 420mg 14ml', brand: 'Perjeta', price: 3985.87 },
  { product: 'Herceptin Vial 440mg (local repacking)', brand: 'Herceptin', price: 4535.5 },
  { product: 'Herceptin 600mg/5ml 1Vial SC CN', brand: 'Herceptin', price: 5128.2 },
];

const locations = [
  ['辽宁省', '沈阳市'], ['辽宁省', '大连市'], ['辽宁省', '辽阳市'], ['辽宁省', '锦州市'],
  ['辽宁省', '阜新市'], ['辽宁省', '铁岭市'], ['吉林省', '长春市'], ['吉林省', '吉林市'],
  ['吉林省', '延边州'], ['黑龙江省', '哈尔滨市'], ['黑龙江省', '牡丹江市'], ['黑龙江省', '齐齐哈尔市'],
] as const;

const distributors = ['北区配送中心 A', '北区配送中心 B', '省级医药供应链 C'];

const makeRandom = (seed: number) => () => {
  seed = (seed * 1664525 + 1013904223) >>> 0;
  return seed / 4294967296;
};

const ymd = (date: Date) => date.toISOString().slice(0, 10);

export const createDemoDataset = (): DashboardDataset => {
  const random = makeRandom(20260817);
  const terminals = Array.from({ length: 64 }, (_, index) => {
    const [province, city] = locations[index % locations.length];
    return {
      code: `DEMO-${String(index + 1).padStart(3, '0')}`,
      name: `${city.replace(/市|州/g, '')}${index % 3 === 0 ? '中心医院' : index % 3 === 1 ? '人民医院' : '肿瘤专科终端'}${index + 1}`,
      province,
      city,
      flowType: index % 4 === 0 ? '目标医院' : '特药药店零售',
    };
  });
  const start = new Date('2026-01-02T00:00:00+08:00');
  const end = new Date('2026-08-16T00:00:00+08:00');
  const dayCount = Math.round((end.getTime() - start.getTime()) / 86400000);
  const records: SalesRecord[] = [];
  for (let index = 0; index < 1280; index += 1) {
    const terminal = terminals[Math.floor(random() * terminals.length)];
    const selector = random();
    const productIndex = selector < 0.47 ? 0 : selector < 0.53 ? 1 : selector < 0.73 ? 2 : selector < 0.91 ? 3 : 4;
    const item = products[productIndex];
    const date = new Date(start);
    date.setDate(date.getDate() + Math.floor(random() * dayCount));
    const isReturn = random() < 0.025;
    const quantity = (1 + Math.floor(random() * (productIndex === 0 ? 8 : 5))) * (isReturn ? -1 : 1);
    const internalAmount = Number((quantity * item.price).toFixed(2));
    records.push({
      salesId: `DEMO-${index + 10001}`,
      product: item.product,
      brand: item.brand,
      businessUnit: 'Oncology',
      quantity,
      internalAmount,
      saleDate: ymd(date),
      customerCode: terminal.code,
      customerName: terminal.name,
      province: terminal.province,
      city: terminal.city,
      customerType: '医院',
      flowType: terminal.flowType,
      createdAt: '2026-08-17',
      regionManager: '演示大区',
      pm: '演示负责人',
      distributor: distributors[index % distributors.length],
      compass: '罗盘',
      movementType: isReturn ? '退货' : '纯销',
      factoryAmount: Number((internalAmount * 1.17).toFixed(2)),
    });
  }
  records.sort((a, b) => a.saleDate.localeCompare(b.saleDate));
  return {
    records,
    meta: {
      fileName: '内置演示数据（非真实业务数据）',
      sheetName: 'Demo',
      importedAt: '2026-08-17T08:00:00.000Z',
      rowCount: records.length,
      dateMin: records[0].saleDate,
      dateMax: records.at(-1)?.saleDate ?? records[0].saleDate,
      headerRow: 1,
      warnings: [],
      demo: true,
    },
  };
};
